<template>
    <n-result status="error" title="Failed">
        <template #footer>
            <n-button type="error" ghost @click="close">OK</n-button>
        </template>
        <p class="descriptiion">There was a technical issue, please try again later.</p>
    </n-result>
</template>

<script>
import {NResult, NButton} from "naive-ui"
export default{
    name:"ErrorResult",
    props:["modalClose"],
    components:{
        NResult, 
        NButton
    },
    setup(props,{emit}){
        const close = () =>{
            emit("modalClose")
        }
        return{
            close
        }
    }
}
</script>

<style scoped>
.descriptiion{
    text-align:center
}
</style>